@if (isVisible()) {
  <div class="block-ui h-full w-full">
    <div class="backdrop w-full h-full"></div>
    <div class="content h-full w-full">
      <ng-content></ng-content>
    </div>
  </div>
}
